
























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { HTTP } from "@/plugins/axios";
import moment from "moment";
moment.locale("es-MX");

@Component
export default class CortesiasPanel extends Vue {
  @Prop({ type: Object })
  private info!: any;

  private disabledSend: boolean = false;
  private name: string = "CortesiasPanel";
  private loading: boolean = false;
  private loadingReSendEmail: boolean = false;
  private data: object = {
    user: "",
    pass: "",
  };
  private headers = [
    {
      text: "Fecha",
      align: "left",
      sortable: true,
      value: "createdAt",
    },
    { text: "Nombre", value: "solName" },
    { text: "Email", value: "solEmail" },
    { text: "Acciones", value: "acciones" },
  ];

  private infoCortesias: any = {
    solName: "",
    solEmail: "",
    quantity: 1,
    patrocinador: null,
  };

  private tableCortesias: any[] = [];

  @Watch("info")
  private watchInfo(v: any) {
    console.log("watchInfo :: ", v);
    this.infoCortesias.solName = v.item.respName;
    this.infoCortesias.solEmail = v.item.respEmail;
    this.infoCortesias.patrocinador = v.item;
  }

  private get cantidadCortesias() {
    let res: number[] = [];
    const totalRed = this.info.item.solicitados.length;
    const totalToRed = this.info.item.folioEnd - this.info.item.folioBeg;
    const ledRed = totalToRed - totalRed;

    console.log(totalRed + " - " + totalToRed + " = " + ledRed);
    if (ledRed <= 0) {
      res = [0];
      this.disabledSend = true;
    } else if (ledRed >= 10) {
      res = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    } else if (ledRed > 0 && ledRed < 10) {
      for (let i = 1; i <= ledRed; i++) {
        // console.log('i :: ', i)
        res.push(i);
      }
    }

    return res;
  }

  private enviarCortesia() {
    console.log("enviarCortesia :: ", this.infoCortesias);
    this.loading = true;
    HTTP.post("boleto-especial/send-cortesias", this.infoCortesias)
      .then((response) => {
        console.log("enviarCortesia :: response :: ", response.data);
        this.$store.commit("setSnackbarMsg", {
          text: "Cortesias Enviadas.",
          color: "success",
          show: true,
          timeout: 2000,
        });
        this.loadCortesias();
      })
      .catch((e) => {
        console.log("enviarCortesia :: catch :: ", e.response.data);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private loadCortesias() {
    HTTP.get("boleto-especial/" + this.info.item.id + "/cortesias")
      .then((response) => {
        console.log("loadCortesias :: response :: ", response.data);
        this.tableCortesias = response.data.solicitados.sort((a: any, b: any) =>
          b.createdAt.localeCompare(a.createdAt)
        );
        this.info.item = response.data;
      })
      .catch((e) => {
        console.log("loadCortesias :: catch :: ", e.response.data);
      })
      .finally(() => {
        this.loadingReSendEmail = false;
      });
  }

  private reSendEmail(id: string) {
    HTTP.get("boleto-especial/" + id + "/resend-email")
      .then((response) => {
        console.log("reSendEmail :: response :: ", response.data);
        this.$store.commit("setSnackbarMsg", {
          text: "El email ha sido, re-enviado.",
          color: "success",
          show: true,
          timeout: 2000,
        });
      })
      .catch((e) => {
        console.log("reSendEmail :: catch :: ", e.response.data);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private viewPDF(id: string) {
    HTTP.get("boleto-especial/" + id + "/view-pdf-cortesia")
      .then((response) => {
        console.log("viewPDF :: response :: ", response.data);
        window.open(
          process.env.VUE_APP_AXIOS_BASE_URL + "conekta/pdf/" + response.data,
          "_blank"
        );
      })
      .catch((e) => {
        console.log("viewPDF :: catch :: ", e.response.data);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private beforeMount() {
    console.log("beforeMount :: ", this.name);
    if (this.info !== null) this.watchInfo(this.info);
    this.loadCortesias();
  }
}
